module.exports = __webpack_public_path__ + "media/src/images/feature-03-d58b02810354a0294b37fe3593316c38.png";